<app-lista-dados
  [upTitulo]="'Veículos sem usuário'"
  [upIcone]="'person_off'"
  [upCor]="'3F51B5'"
  [upDados]="veiculos"
  [upColunas]="colunas"
  [upHabilitaBotaoIncluir]="false"
  [upHabilitaEditarLinha]="false"
  [upHabilitaContador]="true"
  [upHabilitaFiltroRapido]="true"
  [upCarregando]="!!subscription"
  (ueBotaoEditar)="onEdit($event)"
  (ueBotaoExcluir)="onDelete($event)">
</app-lista-dados>

